/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CompaniesInputs */

const cs_nav_companies = /** @type {(inputs: Nav_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemocnice`)
};

const sk_nav_companies = /** @type {(inputs: Nav_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemocnice`)
};

const en_nav_companies = /** @type {(inputs: Nav_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hospitals`)
};

/**
* | output |
* | --- |
* | "Hospitals" |
*
* @param {Nav_CompaniesInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_companies = /** @type {((inputs?: Nav_CompaniesInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CompaniesInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_companies(inputs)
	if (locale === "sk") return sk_nav_companies(inputs)
	return en_nav_companies(inputs)
});